import React from 'react';
import isAfter from '../utils/is.after';

const stepStyle = (progressBarStep, appStateStep) =>
  isAfter(progressBarStep, appStateStep) ? 'pending' : 'visited';

const ProgressBar = ({ step, messages }) => (
  <aside className="progressbar">
    <ol>
      <li className={stepStyle('miniApp', step)}>
        <span className="landing-page-display">1. Check your rate</span>
      </li>
      <li className={stepStyle('quotes', step)}>
        <span className="landing-page-display">2. Select your loan term</span>
      </li>
      <li className={stepStyle('fullApp', step)}>
        <span className="landing-page-display">3. Apply for loan</span>
      </li>
    </ol>
  </aside>
);

export default ProgressBar;
